import {
  Autocomplete,
  Avatar,
  Badge,
  Box,
  Grid,
  List,
  ListItem,
  Menu,
  TextField,
} from "@mui/material";
import styled from "styled-components";
import { theme } from "styles/mui-config";

export const StyledContainer = styled(Grid)`
  background-color: ${theme.palette.secondary.light};
  border-radius: 32px 32px 4px 4px;
  box-shadow: 0 0 2px gray;
  width: 100%;
  position: relative !impotant;
  z-index: 0 !important;
`;

export const StyledChatBox = styled(Grid)`
  background-color: #f8f8fa;
  height: 590px;
  width: 100%;
  overflow-y: hidden;
`;

export const StyledChatHeader = styled(Box)`
  position: sticky;
  top: 0;
  z-index: 9999999999;
  background-color: ${theme.palette.primary.dark};
  background: linear-gradient(
    0deg,
    ${theme.palette.primary.dark} 0%,
    ${theme.palette.primary.light} 100%
  );

  width: 100%;
  height: auto !important;
  padding: 20px 0;
  border-radius: 32px 32px 0 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  border-bottom: 1px solid ${theme.palette.primary.main};

  ${theme.breakpoints.down("md")} {
    flex-direction: column;
    width: 100% !important;
    align-items: start;
  }
`;

export const StyledAvatarBox = styled("div")`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StyledAvatar = styled(Avatar)`
  width: 50px !important;
  height: 50px !important;
  margin: 0 24px;
  font-size: 18px !important;
  border: 2px solid #fff;
`;

export const StyledAvatarList = styled(Avatar)`
  width: 50px !important;
  height: 50px !important;
  font-size: 18px !important;
  border: 2px solid #fff;
`;

export const StyledMessageBox = styled(Box)`
  display: flex;
  width: 50% !important;
  margin: 0 24px 24px 24px;
  align-self: ${(props) => (props.$is_reciver ? "end" : "start")};
  justify-content: ${(props) => (props.$is_reciver ? "end" : "start")};

  & div.active {
    background-color: ${(props) =>
      props.$is_reciver ? theme.palette.primary.dark : "#ccc !important"};
  }
`;
export const StyledTextMessageBox = styled("div")`
  cursor: pointer;
  transition: all 300ms;
  background-color: ${(props) =>
    props.$is_reciver ? theme.palette.primary.main : "#fff"};
  max-width: fit-content !important;
  height: auto !important;
  font-size: 18px !important;
  color: ${(props) => (props.$is_reciver ? "#fff" : "#333")};
  padding: 16px;
  border-radius: ${(props) =>
    props.$is_reciver ? "16px 16px 16px 0" : "16px 16px 0 16px"};

  ${theme.breakpoints.down("md")} {
    max-width: 100% !important;
    font-size: 16px !important;
  }

  ${theme.breakpoints.down("sm")} {
    max-width: 100% !important;
    font-size: 14px !important;
  }
`;

export const StyledMessageTimeBox = styled("div")`
  width: 100%;
  margin-top: 8px;
  display: flex;
  justify-content: start;
`;

export const StyledMenu = styled(Menu)`
  width: 100%;
  & .MuiPaper-root {
    border-radius: 16px;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    background-color: ${theme.palette.secondary.light};
  }
`;

export const StyledFileBox = styled("div")`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
  margin-bottom: 8px;
`;

export const StyledDividerBox = styled("div")`
  width: 95%;
  align-self: center;
  color: ${theme.palette.primary.light};
  ${{ ...theme.typography.body2 }};

  & span {
    color: ${theme.palette.primary.light} !important;
  }
  "& > :not(style) + :not(style)": {
    margintop: ${theme.spacing(2)};
  }
`;

export const StyledAutocomplete = styled(Autocomplete)`
  margin: 0 24px;
  width: 40% !important;

  ${theme.breakpoints.down("md")} {
    margin: 20px 24px 0 24px;
    width: calc(100% - 48px) !important;
  }
`;

export const StyledSearchInput = styled(TextField)`
  background-color: #fff;
  margin: 0 24px;
  border-radius: 4px;
  & .MuiOutlinedInput-root {
    border-radius: 4px;
  }
`;

export const StyledConversationHeader = styled(Box)`
  overflow: hidden;
  top: 0;
  z-index: 9999999999;
  background-color: #fff;
  width: 100%;
  height: 80px !important;
  padding: 40px 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #333;
  border-bottom: 1px solid ${theme.palette.primary.main};
`;

export const StyledBadge = styled(Badge)`
  & .MuiBadge-anchorOriginTopRightRectangular {
    margin: 8px 0 0 5px;
  }
`;

export const StyledGridMenu = styled(Grid)`
  transition: all 300ms;
  background-color: #fff;
  z-index: 100000000;
  overflow-y: scroll;
  height: inherit;
  width: ${(props) => (props.open ? "25%" : "0")};
  ${theme.breakpoints.down("md")} {
    width: ${(props) => (props.open ? "45%" : "0")};
    position: absolute;
    height: inherit;
  }
  ${theme.breakpoints.down("sm")} {
    width: ${(props) => (props.open ? "65%" : "0")};
    position: absolute;
    height: inherit;
  }
`;

export const StyledGridChat = styled(Grid)`
  transition: all 300ms;
  display: flex;
  flex-direction: column !important;
  padding-top: 36px;
  overflow-y: auto;
  height: inherit;
  width: ${(props) => (props.open ? "75%" : "100%")};
  ${theme.breakpoints.down("md")} {
    width: 100%;
  }
`;

export const StyledList = styled(List)`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 10px;
`;
export const StyledListItem = styled(ListItem)`
  background: ${(props) =>
    props.active
      ? `linear-gradient(
      0deg,
      ${theme.palette.primary.dark} 0%,
      ${theme.palette.primary.light} 100%
    )`
      : "#f8f8fa"};
  width: calc(100% - 20px) !important;
  box-sizing: border-box;
  padding-bottom: 2px;
  color: ${(props) => (props.active ? "#fff" : "#333")};
  border-radius: 10px;
`;

export const StyledConversationFooter = styled(Grid)`
  transition: all 300ms;
  display: flex;
  flex-direction: column !important;
  height: 100px;
  padding-top: 24px;
  width: ${(props) => (props.open ? "75%" : "100%")};
  ${theme.breakpoints.down("md")} {
    width: 100%;
  }
`;

export const StyledTextField = styled(TextField)`
  transition: all 300ms;
  background-color: #f2f6fc !important;
  width: calc(100% - 48px) !important;
  border-radius: 10px !important;
  & .MuiFilledInput-root {
    border-radius: 10px !important;
    background-color: #f2f6fc !important;
  }
  & .MuiFilledInput-root::before {
    border-radius: 10px !important;
    border: none !important;
  }
  & input {
    border-radius: 10px !important;
    color: #002b7a;
  }
  & label {
    color: #002b7a;
    font-size: 1rem;
  }
  & input:-webkit-autofill,
  & input:-webkit-autofill:hover,
  & input:-webkit-autofill:focus,
  & input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s !important;
  }
`;

export const StyledTempFileBox = styled("div")`
  cursor: pointer;
  transition: all 300ms;
  background-color: #e9e9e9 !important;
  width: 273px !important;
  height: fit-content !important;
  font-size: 14px !important;
  color: #333;
  border-radius: 16px 16px 0 16px;
  margin-left: 10px;

  ${theme.breakpoints.down("md")} {
    max-width: 100% !important;
    font-size: 16px !important;
  }

  ${theme.breakpoints.down("sm")} {
    max-width: 100% !important;
    font-size: 14px !important;
  }
`;
